/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['custom-menu{display:block}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvY3VzdG9tLW1lbnUvY3VzdG9tLW1lbnUuY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2N1c3RvbS1tZW51L2N1c3RvbS1tZW51LmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/custom-menu/custom-menu.component.scss.ngstyle.ts